module.exports = __webpack_public_path__ + "img/orders.31e9d00e.svg";